import NewReport from './NewReport';

export default NewReport;
